import React from 'react';

const StorySection = ({ story }) => {
  return (
    <div className="qv-section">
      <h3 className="rolex-section-title">Story</h3>
      <p className="rolex-story-text">{story}</p>
    </div>
  );
};

export default StorySection;
